export const stepperStyle = {
	wrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		gap: '12px',
	},

	step: {
		width: '100%',
		textAlign: 'left',
		whiteSpace: 'nowrap',
		fontSize: '16px',
		fontStyle: 'normal',
		fontWeight: '700',
		lineHeight: '28px',
		letterSpacing: '0.15px',
	},

	stepInactive: {
		'& p': {
			color: 'var(--neutral-300)',
		},
	},

	stepTitle: {
		fontWeight: 700,
		paddingLeft: '4px',
		paddingBottom: '4px',
		color: ' var(--primary-500)',
	},
};
